import { useEffect, useState } from 'react';
import clsx from 'clsx';
import './style.css';

interface Type {
  title?: string;
  content?: string;
  open?: boolean;
  getValue?: (b: boolean) => void;
  position?: 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right';
  duration?: number;
}
export function Toast(props: Type) {
  const {
    title,
    content,
    open = false,
    getValue,
    position = 'bottom-left',
    duration = 10000,
  } = props;

  const [show, setShow] = useState<boolean>(open);

  useEffect(() => {
    setShow(open);
  }, [open]);

  return (
    <>
      <div
        style={{
          zIndex: 1080,
          ['--bs-toast-transition' as never]: `opacity ${duration}ms linear`,
        }}
        className={clsx(`toast fade`, show && 'show', `toast-${position}`)}
      >
        <div className="toast-header">
          <div className="d-flex justify-content-between w-100">
            {title ? <span>{title}</span> : ''}

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="toast"
              onClick={() => getValue?.(false)}
            ></button>
          </div>
        </div>
        <div className="toast-body">{content}</div>
      </div>
    </>
  );
}
